import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.auth
)

export const selectAuth = createSelector(
    baseSelector,
    (state) => state.isAuth
)

export const selectAuthLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectAuthError = createSelector(
    baseSelector,
    (state) => state.error
)